import { render, staticRenderFns } from "./previous-jobs-list.vue?vue&type=template&id=b63fb0d8&scoped=true"
import script from "./previous-jobs-list.vue?vue&type=script&lang=js"
export * from "./previous-jobs-list.vue?vue&type=script&lang=js"
import style0 from "./previous-jobs-list.vue?vue&type=style&index=0&id=b63fb0d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63fb0d8",
  null
  
)

export default component.exports